module.exports = __webpack_public_path__ + "img/s4.685f18b0.jpg";